const { DateTime } = require('luxon');

import {
  addDonationWizardSteps,
  donationTypes,
  paymentTypes,
} from '@/utils/constants';

export const getDefaultState = () => {
  return {
    addADonation: {
      donorDetails: {
        id: '',
        harnessId: '',
        email: '',
        firstName: '',
        lastName: '',
        fullName: '',
        phoneNumber: '',
        phoneNumberMasked: '',
      },
      existingDonor: null,
      donationDetails: {
        donationType: donationTypes.oneTime, // one-time, recurring, round-up, external
        campaign: null,
      },
      paymentDetails: {
        card: null,
        monthlyDonationAmount: 50,
        cardDonationAmount: null,
        cashDonationDate: DateTime.now().toString(),
        cashDonationAmount: null,
        checkDonationDate: DateTime.now().toString(),
        checkDonationAmount: null,

        achRoutingNumber: null,
        achAccountNumber: null,
        achAccountType: 'individual',
        achConfirmedMandate: false,


        coverProcessingFee: false,
        processingFee: null,

        // Final donation values to use
        donationAmount: null,
        donationDate: null,
        paymentType: paymentTypes.card // card, cash, check,
      },
      confirmDetails: {
        sendConfirmationToDonor: false,
        stripeToken: null,
      },
      wizardCurrentStep: addDonationWizardSteps.donorDetails,
      wizardSteps: addDonationWizardSteps,
      // This is logical, but we only want 3 steps visible
      // wizardStepsCount: Object.keys(addDonationWizardSteps).length,
      wizardStepsCount: 3,
      donationTypes,
      previousState: null,
    },
  };
};
